angular.module('dnecom')
    .controller('FulfillmentDetailsReviewController', ["$scope", "$uibModalInstance", "transaction", "details", "quote", "products", function FulfillmentDetailsReviewController($scope, $uibModalInstance, transaction, details, quote, products) {
        $scope.transaction = transaction;
        $scope.details = details;
        $scope.quote = quote;
        $scope.products = products;

        if ($scope.quote) {
            angular.forEach($scope.quote.fees, function(value, key) {
                $scope.quote.fees[key] = parseFloat(value);
            });

            $scope.quote.total = parseFloat($scope.quote.total);
        }

        $scope.submit = function() {
            $uibModalInstance.close();
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };
    }]);
